import React from 'react'
import FinancialSnapshotCard from './FinancialSnapshotCard'
import { Card, CardContent, CardTitle, CardDescription } from '../ui/Card'

const ConsentRequiredCard = () => (
  <Card id='financial-report-cta'>
    <CardContent>
      <CardTitle>
        <h2 className='mb-3'>Get a snapshot of your finances.</h2>
      </CardTitle>
      <CardDescription>
        <p className='mb-4'>
          We can help you understand your financial situation to better manage your debts.
        </p>

        <a href='/plaid/link' className='btn btn-primary w-100 mb-3' rel='nofollow'>
          Connect my bank account
        </a>

        <p className='text-muted small mb-0'>
          By connecting your account, you authorize us to access your financial information as
          stated in our Terms of Service.
        </p>
      </CardDescription>
    </CardContent>
  </Card>
)

const ReconnectCard = () => (
  <Card id='financial-report-cta'>
    <CardContent>
      <CardTitle>
        <h2 className='mb-3'>Reconnect your bank account</h2>
      </CardTitle>
      <CardDescription>
        <p className='mb-4'>
          Your bank account connection expired. Please reconnect your bank account to view your
          financial report.
        </p>

        <a href='/plaid/link' className='btn btn-primary w-100 mb-3' rel='nofollow'>
          Reconnect my bank account
        </a>

        <p className='text-muted small mb-0'>
          By reconnecting your account, you authorize us to access your financial information as
          stated in our Terms of Service.
        </p>
      </CardDescription>
    </CardContent>
  </Card>
)

const FinancialReport = ({ financialReport }) => {
  if (!financialReport) {
    return null
  }

  switch (financialReport.status) {
    case 'available':
      return <FinancialSnapshotCard financialReport={financialReport.base_report} />
    case 'consent_required':
      return <ConsentRequiredCard />
    case 'reconnect':
      return <ReconnectCard />
    default:
      return null
  }
}

export default FinancialReport
